import { render } from "./SupportComponent.vue?vue&type=template&id=7e203b02&scoped=true"
const script = {}

import "./SupportComponent.vue?vue&type=style&index=0&id=7e203b02&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e203b02"]])

export default __exports__